import { FormControl, Grid, InputLabel, MenuItem, Select, FormControlLabel, Checkbox, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { IUserDialogProps, IUser } from '../../interfaces';



export const UserDialog: React.SFC<IUserDialogProps> = ({
    roles,
    onSubmitUser,
    ...props
}: IUserDialogProps) => {


    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (e.currentTarget.checkValidity()) {
            onSubmitUser({
                userType: guest ? "Guest" : "Member",
                roleId: userRole,
                email: userEmail
            } as IUser)
            setOpen(false);
        }
    }

    const onCancel = () => {
        setErrorMessage(null);
        setUserEmail(undefined);
        setGuest(false);
        setOpen(false);
    }

    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [userRole, setUserRole] = useState<string>(roles[0].roleId);
    const [userEmail, setUserEmail] = useState<string>();
    const [guest, setGuest] = useState<boolean>(false);

    return (
        <span>
            <Button variant="contained" onClick={() => setOpen(true)}>
                Add User
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
            >
                <form
                    onSubmit={(e) => onSubmit(e)}
                    onInvalid={() => setErrorMessage("please check that all required fields have been populated")}
                >
                    <DialogTitle>
                        Add a User
                    </DialogTitle>
                    <DialogContent>
                        <Grid container >
                            <Grid item={true} xs={10} sx={{ p: 0.5 }}>

                                <TextField
                                    sx={{ mb: 1 }}
                                    label="Username"
                                    fullWidth
                                    type="email"
                                    value={userEmail}
                                    onChange={(e) => setUserEmail(e.target.value)}
                                    required
                                    variant="outlined"
                                    placeholder="Please enter an email address"
                                />

                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <InputLabel id="user-role-select-label">User Role</InputLabel>
                                    <Select
                                        labelId="user-role-select-label"
                                        id="user-role-select"
                                        value={userRole}
                                        label="User Role"
                                        onChange={(e) => setUserRole(e.target.value)}
                                    >
                                        {
                                            roles.map(x => {
                                                return <MenuItem value={x.roleId}>{x.name}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={guest}
                                            onChange={(e) => setGuest(e.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label="Invite this user as a guest?"
                                />
                            </Grid>
                        </Grid>

                        {errorMessage &&
                            <DialogContentText color="error">
                                {errorMessage}
                            </DialogContentText>
                        }

                    </DialogContent>
                    <DialogActions>

                        <Button onClick={onCancel} color="warning">Cancel</Button>

                        <Button type="submit">Save</Button>

                    </DialogActions>

                </form>
            </Dialog>
        </span>
    );
}